import React, { useState } from 'react';

const LoginForm = ({ onLogin, isLoading, error }) => {
  const [credentials, setCredentials] = useState({
    host: '78.141.195.42',
    port: '8000',
    username: 'admin',
    password: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onLogin(credentials);
  };

  const handleChange = (field, value) => {
    setCredentials(prev => ({
      ...prev,
      [field]: value
    }));
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <div className="logo">
            <img src="/Play Logo Web Player.png" alt="PlayFM Logo" className="logo-image" />
            <h1>PlayFm Stream Monitor</h1>
          </div>
          <p className="login-subtitle">
            Connect to your Icecast server to monitor streams and listeners
          </p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="host">Icecast Server Host</label>
            <input
              type="text"
              id="host"
              value={credentials.host}
              onChange={(e) => handleChange('host', e.target.value)}
              placeholder="localhost or your-server.com"
              required
              disabled={isLoading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="port">Port</label>
            <input
              type="number"
              id="port"
              value={credentials.port}
              onChange={(e) => handleChange('port', e.target.value)}
              placeholder="8000"
              min="1"
              max="65535"
              required
              disabled={isLoading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="username">Admin Username</label>
            <input
              type="text"
              id="username"
              value={credentials.username}
              onChange={(e) => handleChange('username', e.target.value)}
              placeholder="admin"
              required
              disabled={isLoading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Admin Password</label>
            <input
              type="password"
              id="password"
              value={credentials.password}
              onChange={(e) => handleChange('password', e.target.value)}
              placeholder="Enter your admin password"
              required
              disabled={isLoading}
            />
          </div>

          {error && (
            <div className="error-message">

              <div>
                <strong>Connection Failed</strong>
                <p>{error}</p>
              </div>
            </div>
          )}

          <button 
            type="submit" 
            className="login-button"
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <div className="spinner-small"></div>
                Connecting...
              </>
            ) : (
              'Connect to Icecast'
            )}
          </button>
        </form>

        <div className="login-footer">
          <div className="help-section">
            <h3>Need Help?</h3>
            <ul>
              <li>Make sure your Icecast server is running</li>
              <li>Verify admin interface is enabled in icecast.xml</li>
              <li>Check that the admin username/password are correct</li>
              <li>Ensure the server is accessible from this location</li>
            </ul>
          </div>

          <div className="security-note">

            <p>Your credentials are only used to connect to your Icecast server and are not stored permanently.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;